/** URL pública de confirmación de correo (Supabase `emailRedirectTo` / Redirect URLs). */
export const COMENSAL_SIGNUP_REDIRECT_URL =
  'https://asgastronomico.com/comensal/correo-verificado';

/** Deep link para volver a la app Flutter tras verificar el correo. */
export const COMENSAL_APP_DEEP_LINK_REGISTRO_CONFIRMAR = 'asgastronomico://registro/confirmar';

/** Detecta parámetros típicos de Supabase Auth tras confirmar email. */
export function urlPareceConfirmacionCorreoSupabase(href?: string): boolean {
  const raw =
    href ??
    (typeof window !== 'undefined' ? `${window.location.search}${window.location.hash}` : '');
  if (!raw) return false;
  return (
    raw.includes('code=') ||
    raw.includes('token_hash=') ||
    raw.includes('access_token')
  );
}
